import CompanyStatusPermission from "@/interfaces/CompanyStatusPermission";
import type { CompanyStatusPermissionUpdatePayload } from "@/interfaces/CompanyStatusPermission";
import api from "../api";

export const companyStatusPermissions = api.injectEndpoints({
  endpoints: (build) => ({
    getCompanyStatusPermissions: build.query<CompanyStatusPermission[], void>({
      query: () => ({
        url: `/company-status-permissions`,
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ id }) => ({
                type: "CompanyStatusPermissions" as const,
                id,
              })),
              { type: "CompanyStatusPermissions", id: "LIST" },
            ]
          : [{ type: "CompanyStatusPermissions", id: "LIST" }],
    }),
    updateCompanyStatusPermissions: build.mutation<
      CompanyStatusPermission[],
      CompanyStatusPermissionUpdatePayload
    >({
      query: (body) => ({
        url: `/company-status-permissions`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: [{ type: "CompanyStatusPermissions", id: "LIST" }],
    }),
  }),

  overrideExisting: true,
});

export const {
  useGetCompanyStatusPermissionsQuery,
  useUpdateCompanyStatusPermissionsMutation,
} = companyStatusPermissions;
